import { apiGet, apiPost } from './api';

export interface AdminAccount {
  id: number;
  username: string;
  name: string;
  openId: string;
  loginType: string;
  roleId: number | null;
  roleName: string;
  status: number;
  lastLoginTime: string | null;
  createTime: string;
}

export interface AdminRole {
  id: number;
  name: string;
  description: string;
  menuKeys: string;
  status: number;
  createTime: string;
}

export interface MenuDef {
  key: string;
  label: string;
}

// ===== 账号管理 =====

export async function getAccountList(): Promise<AdminAccount[]> {
  const res = await apiGet<{ code: number; data: AdminAccount[]; msg?: string }>('/api/admin-accounts/list');
  if (res.code !== 0) throw new Error(res.msg || '获取账号列表失败');
  return res.data;
}

export async function createAccount(data: { username: string; password: string; name: string; roleId?: number }): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/admin-accounts/create', data);
  if (res.code !== 0) throw new Error(res.msg || '创建账号失败');
}

export async function updateAccountStatus(id: number, status: number): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/admin-accounts/update-status', { id, status });
  if (res.code !== 0) throw new Error(res.msg || '操作失败');
}

export async function resetAccountPassword(id: number, password: string): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/admin-accounts/reset-password', { id, password });
  if (res.code !== 0) throw new Error(res.msg || '重置密码失败');
}

export async function updateAccountRole(id: number, roleId: number | null): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/admin-accounts/update-role', { id, roleId });
  if (res.code !== 0) throw new Error(res.msg || '修改角色失败');
}

// ===== 角色管理 =====

export async function getRoleList(): Promise<AdminRole[]> {
  const res = await apiGet<{ code: number; data: AdminRole[]; msg?: string }>('/api/admin-roles/list');
  if (res.code !== 0) throw new Error(res.msg || '获取角色列表失败');
  return res.data;
}

export async function createRole(data: { name: string; description?: string; menuKeys: string }): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/admin-roles/create', data);
  if (res.code !== 0) throw new Error(res.msg || '创建角色失败');
}

export async function updateRole(data: { id: number; name?: string; description?: string; menuKeys?: string }): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/admin-roles/update', data);
  if (res.code !== 0) throw new Error(res.msg || '更新角色失败');
}

export async function updateRoleStatus(id: number, status: number): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/admin-roles/update-status', { id, status });
  if (res.code !== 0) throw new Error(res.msg || '操作失败');
}

export async function getMenuList(): Promise<MenuDef[]> {
  const res = await apiGet<{ code: number; data: MenuDef[]; msg?: string }>('/api/admin-roles/menus');
  if (res.code !== 0) throw new Error(res.msg || '获取菜单列表失败');
  return res.data;
}
